import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { LoadingService } from '@core/services/loading.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import Swal from 'sweetalert2'; // optional for confirmation popup
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-books',
  templateUrl: './books.component.html',
  styleUrls: ['./books.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BooksComponent implements OnInit {
  public arrCoupons: any[] = [];
 currentLang = this.translate.currentLang || this.translate.getDefaultLang();

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
        private loading : LoadingService, 
    
    private router: Router, 
    private modal : NgbModal , 
    private language : LanguageService,private translate: TranslateService
  ) { this.currentLang = this.translate.currentLang || this.translate.getDefaultLang();

  this.translate.onLangChange.subscribe(lang => {
    this.currentLang = lang.lang;
  });
} 

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 8;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;
books: any[] = [];
// currentPage = 1;
// totalItems = 0;
searchValue = '';

 
  public levels: any[] = [];
  public tempData = [];
  // public books :any 
  public bookDetails : any
  public lang : any

  @ViewChild(DatatableComponent) table: DatatableComponent;


public totalPages = 8;
public pagesToShow: number[] = [];

  ngOnInit(): void {
    this.getBooks();
    this.language.currentLang.subscribe((res: string) => {
      this.lang = res;
    })
  }

       /*----------  Handling image Error  ----------*/
  handleImageError(event) {
    event.target.src = 'assets/images/icons/logo.jpg';
  }
 
  // getBooks(){ 
  //       this.loading.show();  

  //   this.apisService.getBooks(this.currentPage).subscribe((res) => {
  //             this.loading.hide();

  //     this.books = res.data;
  //     this.totalItems = this.books.length;
  //   });
  // }

// getBooks() {
//   this.loading.show();

//   this.apisService
//     .getBooks(this.currentPage, this.searchValue)
//     .pipe(
//       finalize(() => {
//         this.loading.hide();
//       })
//     )
//     .subscribe({
//       next: (res: any) => {
//         this.books = res?.data || [];
//         this.totalItems = res?.total || 0;
//       },
//       error: () => {}
//     });
// }

getBooks(page: number = 1) {
  this.currentPage = page;
  this.loading.show();

  this.apisService.getBooks(this.currentPage, this.searchValue)
    .pipe(finalize(() => this.loading.hide()))
    .subscribe((res: any) => {
      this.books = res.data || [];

      // ✅ FORCE stable pagination
      if (res.total) {
        this.totalItems = res.total;
      } else {
        // assume at least 8 pages always
        this.totalItems = Math.max(
          this.totalItems,
          this.itemsPerPage * 1000
        );
      }
    });
}


onPageChange(page: number) {
  if (page === this.currentPage) return;
  this.getBooks(page);
}


// onPageChange(page: number) {
//   this.getBooks(page);
// }
goToPage(page: number) {
  this.currentPage = page;
  this.getBooks(); // call your API with the new page
}

confirmDelete(id: number): void {
  this.translate.get(['MENU.DASHBOARD.OK', 'MENU.DASHBOARD.CANCEL']).subscribe(translations => {
    Swal.fire({
      title: this.lang == 'en' ? 'Are you sure?' : 'هل أنت متأكد',
      text: this.lang == 'en' ? 'This will delete the book permanently.' : 'سيتم حذف الكتاب بشكل نهائي.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: translations['MENU.DASHBOARD.OK'],
      cancelButtonText: translations['MENU.DASHBOARD.CANCEL'],
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading.show(); // ✅ Show loading while deleting

        this.apisService.deleteBooks(id).subscribe({
          next: () => {
            this.loading.hide(); // ✅ Hide loading before success alert

            this.translate.get(['MENU.DASHBOARD.OK']).subscribe(translations => {
              Swal.fire({
                title: this.lang == 'en' ? 'Deleted!' : 'تم الحذف',
                text: this.lang == 'en' ? 'The book has been deleted.' : 'تم حذف الكتاب.',
                icon: 'success',
                confirmButtonText: translations['MENU.DASHBOARD.OK']
              }).then(() => {
                this.getBooks(); // ✅ reload data after user confirms alert
              });
            });
          },
          error: () => {
            this.loading.hide(); // ✅ Hide loading before error alert

            this.translate.get(['MENU.DASHBOARD.OK']).subscribe(translations => {
              Swal.fire({
                title: this.lang == 'en' ? 'Error!' : 'خطأ',
                text: this.lang == 'en' ? 'Something went wrong.' : 'حدث خطأ ما.',
                icon: 'error',
                confirmButtonText: translations['MENU.DASHBOARD.OK']
              });
            });
          },
        });
      }
    });
  });
}


 
 
  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  isArabic(text: string): boolean {
  return /[\u0600-\u06FF]/.test(text);
}
  
  open(content : any , row : any){ 
  this.bookDetails = row
  console.log(this.bookDetails)
  this.modal.open(content, { centered: true , size: 'lg' });
}

close(){
  this.modal.dismissAll();
}
 

  // filterUpdate(event) {
  //   const val = event.target.value.toLowerCase();
  //   this.arrCoupons = this.tempData.filter((d) =>
  //     d.code.toLowerCase().includes(val)
  //   );
  //   this.table.offset = 0;
  // }

  /*----------  Pagination Functions   ----------*/
// next(){ 
//   this.currentPage++
//   this.getBooks()
// }
// prev(){ 
//   this.currentPage--
//   this.getBooks()
// }


filterUpdate(event: any) {
  this.searchValue = event.target.value;
  this.currentPage = 1; // مهم جدًا
  this.getBooks();
}

}
